module.exports = __webpack_public_path__ + "static/img/bg70.18e48ef5.png";